import { useEffect, useState } from "react";
import { api } from '../../components/api/api'

export default function BuscarRecibos() {
    const [termo, setTermo] = useState("");
    const [loading, setLoading] = useState(false);
    const [recibos, setRecibos] = useState([]);

    useEffect(() => {
        var loader = document.getElementById("loader-page");
        if (loader)
            loader.style.display = 'none';
    }, [])

    const buscarRecibos = async () => {
        if (!termo.trim()) return;

        setLoading(true);

        api.get(`/api/Recibo/BuscarReciboPorNomePagador?pagador=${termo}`, res => {
            setRecibos(res.data);
            setLoading(false);
        }, (error) => {
            console.error(error);
            setLoading(false);
            alert("Erro ao buscar recibos");
        })
    };

    const formataData = (data) => {
        var split = String(data).split("T")[0].split('-');

        return `${split[2]}/${split[1]}/${split[0]}`
    }

    return (
        <section className='content'>
            <div className="bg-white rounded-2xl shadow-lg" style={{ padding: 20 }}>
                <h1 className="text-3xl font-bold text-gray-800 mb-6">
                    Buscar Recibos
                </h1>

                <div className="flex gap-3 mb-6">
                    <input
                        type="text"
                        placeholder="Digite nome do pagador..."
                        value={termo}
                        onChange={(e) => setTermo(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                buscarRecibos();
                            }
                        }}
                        className="flex-1 border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                    />

                    <button
                        onClick={buscarRecibos}
                        disabled={loading}
                        className="bg-blue-600 hover:bg-blue-700 text-white rounded-lg rounded-xl font-semibold transition"
                        style={{ padding: 6 }}
                    >
                        {loading ? "Buscando..." : "Buscar"}
                    </button>
                </div>

                <div className="overflow-x-auto mt-5">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-200 text-gray-700">
                                <th className="text-left p-3">Recibo Id</th>
                                <th className="text-left p-3">Cliente Id</th>
                                <th className="text-left p-3">Pedido Id</th>
                                <th className="text-left p-3">Cliente</th>
                                <th className="text-left p-3">Pagador</th>
                                <th className="text-left p-3">Forma Pagamento</th>
                                <th className="text-left p-3">Valor Pago</th>
                                <th className="text-left p-3">Data Recibo</th>
                            </tr>
                        </thead>

                        <tbody>
                            {recibos.length === 0 && !loading && (
                                <tr>
                                    <td
                                        colSpan={8}
                                        className="text-center p-6 text-gray-500"
                                    >
                                        Nenhum recibo encontrado
                                    </td>
                                </tr>
                            )}

                            {recibos.map((item, index) => (
                                <tr
                                    key={index}
                                    className="border-b hover:bg-gray-50 transition"
                                >
                                    <td className="p-3">#{item.reciboId}</td>
                                    <td className="p-3">#{item.clienteId}</td>
                                    <td className="p-3">#{item.pedidoId}</td>

                                    <td className="p-3 font-medium">
                                        {item.nomeCliente}
                                    </td>
                                    <td className="p-3 font-medium">
                                        {item.nomePagador}
                                    </td>

                                    <td className="p-3">
                                        {item.formaPagamento}
                                    </td>

                                    <td className="p-3 text-green-700 font-semibold">
                                        {
                                            new Intl.NumberFormat('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            }).format(item.valorPago)
                                        }
                                    </td>

                                    <td className="p-3">
                                        {formataData(item.dataRecibo)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
}